import FetchCurtainPrice from "./FetchCurtainPrice";
import FetchCurtainTemplate from "./FetchCurtainTemplate";
import {_} from "vue-underscore";

export const FetchCurtain = {
  mixins: [FetchCurtainPrice, FetchCurtainTemplate],
  created() {
    this.debouncedFetchCurtainPriceData = _.debounce(
      () => this.fetchCurtainPriceData(), 500
    )
    this.debouncedFetchCurtainTemplate = _.debounce(
      () => this.fetchCurtainTemplate(), 500
    )
  },
  watch: {
    curtainType() { this.debouncedFetchCurtainTemplate() },
    mainFabric() { this.debouncedFetchCurtainTemplate() },
    'railRodParameters.length': {
      handler(val) {
        !!val && this.debouncedFetchCurtainTemplate()
      }
    },
    curtainParameters() { this.debouncedFetchCurtainPriceData() },
  },
}
